import React, { useState } from 'react'
import Tube from './Tube'
import reviewData from './Data'
import { Dialog } from "@material-ui/core";
import Review from './Review';
import AllStars from './Star.js'
import { Icon } from '@dashboard/common/src/component/Component'
import logo from '../../images/koshlogo.png'

const Reviews = ({ setDialogOpen }) => {
    const [showMore, setShowMore] = useState(false)
    const [showAllReviews, setShowAllReviews] = useState(false)
    const reviews = reviewData.slice(0, 3)
    const handleShowMore = () => {
        setDialogOpen(true)
        setShowMore(!showMore)
        setShowAllReviews(true)
    }
    return (
        <div style={{
            marginTop: 10,
            padding: 10,
            boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px'
        }}>
            <div style={{ border: '0px solid blue', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ border: '0px solid pink', marginRight: 15 }}>
                    <p style={{ fontSize: 56, margin: 0 }}>4.4</p>
                    <p style={{ margin: 0 }}><AllStars rating={5} /></p>
                    <p style={{ fontSize: 14, fontWeight: 300 }}>27.3K reviews</p>
                </div>
                <div style={{ border: '0px solid green', paddingLeft: 10, paddingTop: 10, flexGrow: 1 }}>
                    <Tube num={5} percentage={75} />
                    <Tube num={4} percentage={15} />
                    <Tube num={3} percentage={5} />
                    <Tube num={2} percentage={5} />
                    <Tube num={1} percentage={10} />
                </div>
                <div></div>
            </div>

            <div style={{marginTop:10}}>
                {reviews.map(ele => <Review obj={ele} />)}
                <p onClick={handleShowMore} style={{ fontSize: 14, color: '#01875f', fontWeight: 600, cursor: 'pointer' }}>Show More</p>
            </div>

            <Dialog open={showAllReviews} maxWidth='xs' fullScreen style={{ minHeight: '100%' }} onClose={() => setShowAllReviews(false)}>
                <div>
                    <div style={{display: 'flex', alignItems: 'center' }}>
                        <button
                            onClick={() => { setShowAllReviews(false) 
                                             setDialogOpen(false)
                                            }
                                    }
                            style={{
                                height: 30, width: 50, display: 'flex', fontSize: 20, marginTop: 5,  justifyContent: 'center',
                                alignItems: 'center', color: 'black', background: 'white', border: 'none',
                            }}

                        >
                            <Icon className="ni ni-arrow-left"></Icon>
                        </button>
                        <div style={{ display: 'flex', marginTop: 5, alignItems: 'center'}}>
                            <img src={logo} height={30} width={30} />
                            <h4 style={{ marginLeft: 10}}>Kosh - Loan App</h4>
                        </div>
                    </div>
                    <div style={{ height: 1, width: '100%', marginTop: 10, background: 'gray'}}></div>

                    <div style={{ marginTop: 5, width: '95%', padding: 10}}>
                        {reviewData.map(ele => <Review obj={ele} />)}
                    </div>
                </div>
            </Dialog>





        </div>
    )
}

export default Reviews